module.exports = __webpack_public_path__ + "static/media/crane_salmon.78a242cf.svg";